/**
 * Configuration des routes et leurs permissions associées
 * Ce fichier centralise la logique de mapping route -> permission
 */

export interface RouteConfig {
  path: string;
  permission: string;
}

// Configuration des routes et leurs permissions
export const ROUTE_PERMISSIONS: Record<string, string> = {
  '/dashboard': 'get dashboard',
  '/tax/dashboard': 'get taxdashboard',
  '/users/profile': 'get profile',
  '/profile/update': 'get profile',
  '/settings': 'get setting',
  '/clients': 'get company',
  '/products': 'get product',
  '/dealers': 'get dealer',
  '/users': 'get systemuser',
  '/documents': 'get member',
  '/qrcode-requests': 'get qrcodes',
  '/complaints': 'get complaint',
  '/logs': 'get log',
  // Routes tax manquantes
  '/areas': 'get area',
  '/sub-areas': 'get subarea',
  '/institutions': 'get institution',
  '/tax-frequencies': 'get taxfrequency',
  '/tax-types': 'get taxtype',
  '/tax-payers': 'get taxpayer',
  '/tax-collectors': 'get taxcollector',
  '/tax-supervisors': 'get taxsupervisor',
  '/tax-assessments': 'get taxassessment',
  '/tax-natures': 'get taxnature',
  '/tax-payments': 'get taxpayment',
  '/tax/logs': 'get taxlog',
  '/tax/data-uploads': 'get taxdataupload',
  '/categories': 'get productcategory',
  '/sub-categories': 'get subcategory',
  '/roles': 'get role',
};

// Ordre de priorité pour la redirection automatique
export const ROUTE_PRIORITY: RouteConfig[] = [
  { path: '/dashboard', permission: 'get dashboard' },
  { path: '/tax/dashboard', permission: 'get taxdashboard' },
  { path: '/users/profile', permission: 'get profile' },
  { path: '/profile/update', permission: 'get profile' },
  { path: '/settings', permission: 'get setting' },
  { path: '/clients', permission: 'get company' },
  { path: '/products', permission: 'get product' },
  { path: '/dealers', permission: 'get dealer' },
  { path: '/users', permission: 'get systemuser' },
  { path: '/documents', permission: 'get member' },
  { path: '/qrcode-requests', permission: 'get qrcodes' },
  { path: '/complaints', permission: 'get complaint' },
  { path: '/logs', permission: 'get log' },
  // Routes tax par ordre de priorité
  { path: '/tax-payers', permission: 'get taxpayer' },
  { path: '/tax-collectors', permission: 'get taxcollector' },
  { path: '/tax-supervisors', permission: 'get taxsupervisor' },
  { path: '/tax-assessments', permission: 'get taxassessment' },
  { path: '/tax-payments', permission: 'get taxpayment' },
  { path: '/tax/logs', permission: 'get taxlog' },
  { path: '/tax/data-uploads', permission: 'get taxdataupload' },
  { path: '/institutions', permission: 'get institution' },
  { path: '/tax-frequencies', permission: 'get taxfrequency' },
  { path: '/tax-types', permission: 'get taxtype' },
  { path: '/tax-natures', permission: 'get taxnature' },
  { path: '/areas', permission: 'get area' },
  { path: '/sub-areas', permission: 'get subarea' },
  { path: '/categories', permission: 'get productcategory' },
  { path: '/sub-categories', permission: 'get subcategory' },
  { path: '/roles', permission: 'get role' },
];

/**
 * Fonction utilitaire pour obtenir la permission requise pour une route
 */
export const getRequiredPermission = (pathname: string): string | null => {
  return ROUTE_PERMISSIONS[pathname] || null;
};

/**
 * Fonction utilitaire pour vérifier si une route nécessite une permission
 */
export const isProtectedRoute = (pathname: string): boolean => {
  return pathname in ROUTE_PERMISSIONS;
};
